import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Paper, Stack, IconButton } from "@mui/material";

// Icons
import IconAddPhoto from "@mui/icons-material/AddPhotoAlternate";
import IconClose from "@mui/icons-material/Close";
import { updateStorePicture } from "@/Settings/api/AdministrationTools/mutations";

export default function ImageStorePicture(props) {
	const {
		src = "",
		width = "100%",
		height,
		style = { objectFit: "cover" },
		onClick = () => {},
		onMouseLeave = () => {},
		onMouseOver = () => {},
	} = props;

	const replaceImageInputRef = useRef(null);
	const queryClient = useQueryClient();

	const handleReplaceImage = () => {
		replaceImageInputRef.current.click();
	};

	const handleFileUpload = async (event) => {
		const newFiles = event.target.files || [];
		const newFilesArray = Array.from(newFiles);

		let errors = props.validator(newFilesArray);
		if (!errors?.length) {
			await props.uploader(newFilesArray, "REPLACE", props.pictureIndex);
		} else {
			props.setErrors(errors);
		}
	};

	const handleDeleteImage = async () => {
		if (props.numStorePics > 1) {
			await updateStorePicture(props.locationId, "DELETE", null, props.pictureIndex);
			queryClient.invalidateQueries({ queryKey: ["storePicturesList"] });
			props.setErrors([]);
		}
	};

	return (
		<Stack className={"store-img-container"}>
			<input type="file" style={{ display: "none" }} ref={replaceImageInputRef} onChange={handleFileUpload} />
			<img
				src={src}
				alt={"Store Picture"}
				crossOrigin="true"
				width={width}
				height={height}
				style={style || {}}
				className={"store-img" || ""}
				onClick={onClick}
			/>
			<Stack className={"store-img-overlay"}>
				<Paper elevation={0} sx={{ backgroundColor: "transparent" }}>
					<IconButton onClick={handleReplaceImage}>
						<IconAddPhoto className="store-picture-icon replace-img" />
					</IconButton>
					<IconButton
						sx={{ position: "absolute", top: "0", right: "0" }}
						onClick={handleDeleteImage}
						disabled={props.numStorePics < 2}
					>
						<IconClose className="store-picture-icon" />
					</IconButton>
				</Paper>
			</Stack>
		</Stack>
	);
}
